export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'Tabless-tunnus',
      placeholder: 'Tabless-järjestelmän sisäinen tunnus',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    error: 'Muutosten tallentaminen epäonnistui',
    success: 'Muutokset tallennettiin',
  },
  connected: {
    title: 'Tabless on yhdistetty',
    description: 'Tämä integraatio on otettu käyttöön.',
  },
};
